import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/nurikabe.json";
import fr from "@/locales/fr/puzzle-types/nurikabe.json";

export const NURIKABE_NS = "puzzle-types/nurikabe";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerNurikabeTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", NURIKABE_NS))
    i18n.addResourceBundle("en", NURIKABE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", NURIKABE_NS))
    i18n.addResourceBundle("fr", NURIKABE_NS, fr, true, true);
}
